import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { LOCLogo } from '../../assets/images';
import useAuth from '../../hooks/useAuth';
import { useHandleResendEmail } from '../../hooks/useUsers';

type props = {
  deepLinkData: any;
  resendSwitchBoardOnBoardingLink: any;
  resendSwitchBoardOnBoardingLinkError: any;
  pending: boolean;
};

const InvitationExpired: React.FunctionComponent<props> = (props): JSX.Element => {
  const resendEmail = useHandleResendEmail();
  const { logout } = useAuth();

  const handleResendEmail = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    const userId = queryParams.get('user_id');

    if (!token || !userId || isNaN(parseInt(userId))) {
      toast.error("can't find nessary data. please contact support.");
      return;
    }

    const input = {
      userId: parseInt(userId),
      token,
    };
    resendEmail.mutate(input, {
      onSuccess: () => {
        toast.success(`Invite sent successfully`);
      },
    });
  };

  return (
    <div>
      <div className="bg-gray-background-light flex h-screen w-full items-center justify-center">
        <div className="w-96 bg-white px-8 pb-12 pt-8">
          <div className="text-primary w-full">
            <div className="flex justify-center pt-4">
              <img src={LOCLogo} alt="kindly-logo" className="w-56" />
            </div>
            <h3 className="text-bright-blue pt-10 text-xl">Invitation Expired</h3>
            <h3 className="text-gray-dark pt-4 text-sm">
              Your invitation has expired. Request a new invitation below.
            </h3>
            <h3 className="text-gray-dark pt-4 text-sm">The invitation will be valid for 24 hours.</h3>
            <div className="mt-8 flex flex-col justify-center gap-y-4">
              <button
                type="button"
                className="bg-bright-blue rounded-full px-12 py-1.5 text-white"
                onClick={handleResendEmail}
              >
                REQUEST NEW INVITE
              </button>
              <button
                type="button"
                className="bg-bright-blue rounded-full px-12 py-1.5 text-white"
                onClick={() => logout()}
              >
                TO LOGIN
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state: any) => {
  return {
    deepLinkData: state.login?.deepLinkData,
    resendSwitchBoardOnBoardingLink: state.login?.resendSwitchBoardOnBoardingLink,
    resendSwitchBoardOnBoardingLinkError: state.login?.resendSwitchBoardOnBoardingLinkError,
    pending: state.login.pending,
  };
};

export default connect(mapStateToProps)(InvitationExpired);
